import { API_PATH } from '../../config'
import { $ajax } from '../../utils'
import { appendQueryToSayurl } from '../../utils/append-query-to-sayurl.js'
import { resultPop } from './pay.result'

export function windowOpen(url) {
  window.open(
    url,
    'poker_mall_billing',
    'width=461,height=434,left=880,top=100'
  )
}

/** 보유한 피망캐쉬로 구매 : 게임홈 구매 API 호출 /buy/pmangcash */
export function buyPmangCash() {
  /**
   * @typedef {import('./pay.model').PayModel} PayModel
   * @type Backbone.Model<PayModel>
   */
  var model = this.model
  var requestGoodsId = model.get('goodsIdList').join('_')
  var isRequested = model.get('isRequested')
  var vipCouponSelectedId = model.get('vipCouponSelectedId')

  if (!isRequested) {
    model.set({ isRequested: true })
    $ajax(
      API_PATH.BUY_PMANGCASH,
      { goods_id_list: requestGoodsId, vip_coupon_id: vipCouponSelectedId },
      'POST'
    )
      .then(function (res) {
        resultPop(res.result)
      })
      .always(function () {
        model.set({ isRequested: false })
      })
  }
}

/** 선물하기 - 보유한 피망캐쉬로 친구에게 선물 구매 */
export function giftPmangCash() {
  var model = this.model
  var requestGoodsId = model.get('goodsIdList').join('_')
  var gsn = model.get('friendGSN')
  var friendNickname = model.get('friendNickname')
  var isRequested = model.get('isRequested')

  if (!isRequested) {
    $ajax(
      API_PATH.BUY_GIFT,
      {
        target_gsn: gsn,
        nick: friendNickname,
        goods_id_list: requestGoodsId,
      },
      'POST'
    )
      .then(function (res) {
        resultPop(res.result)
      })
      .always(function () {
        model.set({ isRequested: false })
      })
  }
}

// 상품 구매
export function submitGoods(event) {
  event.preventDefault()
  $(event.currentTarget).blur()

  var isChargePmangCash = this.model.get('isChargePmangCash')
  var isSelectPayNow = this.model.get('isSelectPayNow')
  var isSelectPmangCash = this.model.get('isSelectPmangCash')
  var payNowMethod = this.model.get('payNowMethod')
  var billingUrl = this.model.get('billingUrl')
  var vipCouponSelectedId = this.model.get('vipCouponSelectedId') || '0'

  var isValid = this.model.isValid()

  if (!isValid) return

  this.model.setDirty()

  /**
   * UI에서 VIP 쿠폰 ID를 선택했다면, API 가 응답한 결제 URL뒤에 쿠폰 ID를 추가하여 빌링 페이지 호출
   * 빌링에서 결제후 포커 게임홈 bridge 페이지로 이동하면서 vip_coupon_id를 URL 쿼리스트링으로 되돌려주기를 기대
   */
  if (isSelectPmangCash) {
    //  피망 캐쉬 충전후 구매
    if (isChargePmangCash) {
      let url = billingUrl['HP'].pay_buy_count_url
      if (vipCouponSelectedId !== '0') {
        url = appendQueryToSayurl(url, '&vip_coupon_id=' + vipCouponSelectedId)
      }
      this.windowOpen(url)
    } else {
      this.buyPmangCash()
    }
  } else if (isSelectPayNow) {
    // 바로 결제
    let url = billingUrl[payNowMethod].pay_buy_now_count_url
    if (vipCouponSelectedId !== '0') {
      url = appendQueryToSayurl(url, '&vip_coupon_id=' + vipCouponSelectedId)
    }
    this.windowOpen(url)
  }
}

// 선물하기 구매
export function submitGift(event) {
  event.preventDefault()
  $(event.currentTarget).blur()

  var isChargePmangCash = this.model.get('isChargePmangCash')
  var isSelectPayNow = this.model.get('isSelectPayNow')
  var isSelectPmangCash = this.model.get('isSelectPmangCash')
  var payNowMethod = this.model.get('payNowMethod') || 'HP'
  var billingUrl = this.model.get('billingUrl')
  var friendResultCode = this.model.get('resultCode')
  var isValid = this.model.isValid({ validationName: 'gift' })

  if (isValid) {
    switch (friendResultCode) {
      case 1:
        if (isSelectPmangCash) {
          if (isChargePmangCash) {
            this.windowOpen(billingUrl['HP'].pay_buy_count_url)
          } else {
            this.giftPmangCash()
          }
        } else if (isSelectPayNow) {
          this.windowOpen(billingUrl[payNowMethod].pay_buy_now_count_url)
        }
        break
    }
  }
}
export function submitAuto(event) {
  event.preventDefault()
  $(event.currentTarget).blur()
  var _this = this
  var billingUrl = this.model.get('billingUrl')
  var isValid = this.model.isValid()
  if (isValid) {
    _this.windowOpen(billingUrl['HP'])
  }
}
